import { showCustomConfirmDialog } from "../../../../../common/components/dialogs/AppConfirmDialog";
import { ISelectFieldModel } from "../../../../../common/components/forms/inputs/dropdown/models/selectFieldModel";
import { useApiMutation } from "../../../../../common/infrastructure/hooks/useApiMutation";
import { useApiQuery } from "../../../../../common/infrastructure/hooks/useApiQuery";
import { endpointsMetadata } from "../../../../../common/infrastructure/routes/endpointsMetadata";
import { getErrorToast } from "../../../../../common/infrastructure/utilities/toastUtility";
import { IUserModel } from "../models/userModel";

interface IUseSendClientFormDialogProps {
  user?: IUserModel;
  visible: boolean;
  onHide: () => void;
}

export const NO_CLIENT_EMAIL_MESSAGE =
  "Клиентът няма имейл. Първо добавете имейл в профила му.";

/**
 * "Изпрати форма" on a client's profile: the studio's active forms, each sent to the client by
 * email after a confirmation. A client without an email gets an error instead of the confirm.
 */
export const useSendClientFormDialog = ({
  user,
  visible,
  onHide,
}: IUseSendClientFormDialogProps) => {
  // Same query as the class wizard's form dropdown, so the two share the cache.
  const { data: forms, isLoading } = useApiQuery<ISelectFieldModel[]>({
    queryKey: [endpointsMetadata.preReservationForm.getActiveOptions],
    endpoint: endpointsMetadata.preReservationForm.getActiveOptions,
    enabled: visible,
    globalIsLoading: false,
  });

  const { mutate, isLoading: isSending } = useApiMutation<string>();

  const requestSend = (form: ISelectFieldModel) => {
    if (!user || isSending) {
      return;
    }

    const email = user.email?.trim();
    if (!email) {
      getErrorToast(NO_CLIENT_EMAIL_MESSAGE);
      return;
    }

    // A JSX message, not a string: the dialog renders a string as HTML, and the form's
    // name and the email are typed by people.
    showCustomConfirmDialog(
      <>
        Сигурни ли сте, че искате да изпратите формата „{form.name}“ на {email}?
      </>,
      () =>
        mutate(
          {
            endpoint: endpointsMetadata.clientForm.sendForm,
            method: "post",
            payload: { userId: user.id, preReservationFormId: form.id },
          },
          { onSuccess: onHide },
        ),
      () => {},
      "warning",
      "Изпрати",
      "Отказ",
    );
  };

  return {
    forms: forms ?? [],
    isLoading,
    isSending,
    requestSend,
  };
};
